/**
 * No-op ajv-formats stub for browser environments.
 * See ./ajv.ts for rationale.
 */
export default function addFormats(_ajv: unknown): void {}
